import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';

export const FeatureToggle = ({
  app,
  toggle,
  condition,
  alternate,
  children,
}) => {
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    if (getFeature(toggle) && condition) {
      setIsEnabled(true);
    }
  }, []);

  if (typeof children === 'function') {
    return children(isEnabled);
  }
  return isEnabled ? children : alternate;
};

FeatureToggle.propTypes = {
  app: PropTypes.string,
  toggle: PropTypes.string,
  condition: PropTypes.bool,
  alternate: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

FeatureToggle.defaultProps = {
  app: null,
  toggle: null,
  condition: true,
  alternate: null,
  children: null,
};
